import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  IoLocationOutline as LocationIcon,
  IoCallOutline as PhoneIcon,
  IoMailOutline as EmailIcon,
  IoTimeOutline as ClockIcon
} from 'react-icons/io5';
import { FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import logo from '../assets/logo.png';
import './Footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img src={logo} alt="Celebrity Cuts Logo" className="footer-logo-img" />
          <p className="footer-tagline">Where Style Meets Elegance</p>
          <RouterLink to="/links" className="footer-links-link">Links</RouterLink>
        </div>

        <div className="footer-contact">
          <h3 className="footer-heading">Contact Us</h3>
          <div className="contact-item">
            <LocationIcon className="contact-icon" />
            <p>Madhurawada, Visakhapatnam,<br />Andhra Pradesh 530041</p>
          </div>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <a href="tel:07730858858" className="contact-link">077308 58858</a>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <a href="mailto:info@celebritycuts.com" className="contact-link">info@celebritycuts.com</a>
          </div>
        </div>

        <div className="footer-social">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="social-links">
            <a
              href="https://www.instagram.com/celebritycutsinsta/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <FaInstagram className="social-icon" />
            </a>
            <a
              href="https://www.facebook.com/people/celebrity-cuts/100087441225596/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <FaFacebookF className="social-icon" />
            </a>
            <a
              href="https://www.youtube.com/@CelebrityCutsinvizag"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="YouTube"
            >
              <FaYoutube className="social-icon" />
            </a>
          </div>
        </div>

        <div className="footer-hours">
          <h3 className="footer-heading">Working Hours</h3>
          <div className="contact-item">
            <ClockIcon className="contact-icon" />
            <div>
              <p>Monday - Saturday: 8:00 AM - 9:00 PM</p>
              <p>Sunday: 10:00 AM - 9:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Celebrity Cuts. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
